import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Checkbox, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@material-ui/core';
import moment from 'moment';

import AppContext from '../../../App/AppContext';
import { makeStyles, withStyles } from '@material-ui/styles';
import TCardDashboardModal from '../../internal/T-card/Dashboard/T-cardModal';

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: 15
    },
    inputBase: {
        '&.MuiFormControl-fullWidth': {},
        '& .MuiOutlinedInput-inputMarginDense': {
            padding: '13px',
            border: 'none',
            background: 'white',
            borderLeft: '1px solid rgba(0, 0, 0, 0.3)',
            borderTop: '1px solid rgba(0, 0, 0, 0.3)',
            borderBottom: '1px solid rgba(0, 0, 0, 0.3)'
        },
        '.MuiInputBase-root': {
            background: 'white',
            borderLeft: '1px solid rgba(0, 0, 0, 0.3)',
            borderTop: '1px solid rgba(0, 0, 0, 0.3)',
            borderBottom: '1px solid rgba(0, 0, 0, 0.3)'
        }
    },
    table: {
        minWidth: 1250
    },
    title: {
        color: '#f50057',
        marginLeft: 8,
        marginTop: 8,
        marginBottom: 8
    },
    paper: {
        padding: theme.spacing(2),
        color: theme.palette.text.secondary,
        border: '1px solid rgba(0,0,0,0.2)'
    },
    axelTitles: {
        textAlign: 'center',
        color: '#f50057',
        width: '100%'
    },
    headings: {
        color: '#f50057',
        margin: 0,
        marginLeft: -4,
        marginBottom: 20
    }
}));

const StyledTableRow = withStyles(() => ({
    root: {
        cursor: 'pointer'
    }
}))(TableRow);

const StyledTableCell = withStyles(() => ({
    head: {
        fontSize: 15,
        fontWeight: 600,
        backgroundColor: '#bdbdbd82',
        padding: '6px 0px 6px 8px'
    },
    body: {
        fontSize: 14,
        padding: '6px 0px 6px 8px'
    }
}))(TableCell);

const ExistingCardsList = ({ existingTCards, onJobSelect, tableHeight, isHeaderCreateTcardBtnFunc, createTCard }) => {
    const { showToast, showModal, portalSettings } = useContext(AppContext);
    const [openModal, setOpenModal] = useState(false);
    const [tCardID, setTCardID] = useState(null);
    const [state, setState] = useState({ createNewTcard: true });
    const classes = useStyles();

    useEffect(() => {
        setState((prev) => ({ ...prev, createNewTcard: createTCard }));
    }, [createTCard]);

    const legendItems = useMemo(() => {
        if (!portalSettings) return [];
        return [
            {
                label: portalSettings?.portalSettingsCollectionDeliverText,
                background: portalSettings?.portalSettingsCollectionDeliverBgColor || 'black',
                color: portalSettings?.portalSettingsCollectionDeliverTextColor || 'white',
                st: 'cd'
            },
            {
                label: portalSettings?.portalSettingsCustomerWaitingText,
                background: portalSettings?.portalSettingsCustomerWaitingBgColor || 'black',
                color: portalSettings?.portalSettingsCustomerWaitingTextColor || 'white',
                st: 'waiting'
            },
            {
                label: portalSettings?.portalSettingsServiceText,
                background: portalSettings?.portalSettingsServiceBgColor || 'black',
                color: portalSettings?.portalSettingsServiceTextColor || 'white',
                st: 'service'
            },
            {
                label: portalSettings?.portalSettingsInspectionText,
                background: portalSettings?.portalSettingsInspectionBgColor || 'black',
                color: portalSettings?.portalSettingsInspectionTextColor || 'white',
                st: 'inspection'
            },
            {
                label: portalSettings?.portalSettingsMOTText,
                background: portalSettings?.portalSettingsMOTBgColor || 'black',
                color: portalSettings?.portalSettingsMOTTextColor || 'white',
                st: 'mot'
            },
            {
                label: portalSettings?.portalSettingsRepairText,
                background: portalSettings?.portalSettingsRepairBgColor || 'black',
                color: portalSettings?.portalSettingsRepairTextColor || 'white',
                st: 'repair'
            },
            {
                label: portalSettings?.portalSettingsNightShiftText,
                background: portalSettings?.portalSettingsNightShiftBgColor || 'black',
                color: portalSettings?.portalSettingsNightShiftTextColor || 'white',
                st: 'ns'
            },
            {
                label: portalSettings?.portalSettingsRecallJobText,
                background: portalSettings?.portalSettingsRecallJobBgColor || 'black',
                color: portalSettings?.portalSettingsRecallJobTextColor || 'white',
                st: 'recall'
            },
            {
                label: portalSettings?.portalSettingsTachoText,
                background: portalSettings?.portalSettingsTachoBgColor || 'black',
                color: portalSettings?.portalSettingsTachoTextColor || 'white',
                st: 'tacho'
            }
        ];
    }, [portalSettings]);

    const handleTcardOpen = (cond, id) => {
        setOpenModal(cond);
        setTCardID(id);
    };

    const handleCreateTcardChange = (checked) => {
        if (checked) {
            existingTCards.forEach((item) => {
                if (item.isSelected) {
                    onJobSelect(false, item.tCardsID);
                }
            });
        }
        isHeaderCreateTcardBtnFunc(checked);
        setState((prev) => ({ ...prev, createNewTcard: checked }));
    };

    return (
        <>
            <TableContainer style={{ height: tableHeight || '448px', border: '1px solid rgba(0,0,0,0.2)', overflow: 'auto' }}>
                <Table size="small">
                    <TableHead>
                        {/* First Sticky Header - Create Tcard */}
                        {/* {isHeaderCreateTcardBtnFunc && ( */}
                        <TableRow className="header" style={{ top: 0, backgroundColor: '#bdbdbd82', zIndex: 10 }}>
                            <StyledTableCell colSpan={2}>
                                <Grid container spacing={1} alignItems="center">
                                    <Grid item>
                                        {isHeaderCreateTcardBtnFunc && (
                                            <Checkbox
                                                checked={state.createNewTcard}
                                                color="primary"
                                                onChange={(e) => handleCreateTcardChange(e.target.checked)}
                                                disabled={
                                                    // existingTCards.length === 0 ||
                                                    // existingTCards.every((item) => item.isChecBoxkDisabled) ||
                                                    existingTCards.length > 0 ? existingTCards.every((item) => item.isSelected) : false
                                                }
                                                // disabled={existingTCards.every((item) => item.isChecBoxkDisabled)}
                                            />
                                        )}
                                        {isHeaderCreateTcardBtnFunc ? `Create Tcard or ` : ''}Select from existing Tcard
                                    </Grid>
                                    {/* <Grid item>Select from existing Tcard</Grid> */}
                                </Grid>
                            </StyledTableCell>
                        </TableRow>
                        {/* )} */}

                        {/* Second Sticky Header - Select from existing Tcard */}
                        {/* <TableRow
                            className="header"
                            style={{ position: 'sticky', top: isHeaderCreateTcardBtnFunc ? 50 : 0, backgroundColor: '#bdbdbd82', zIndex: 9 }}
                        >
                            <StyledTableCell width="8%" colSpan={2}>
                                Select from existing Tcard
                            </StyledTableCell>
                        </TableRow> */}
                    </TableHead>

                    <TableBody>
                        {existingTCards.length > 0 ? (
                            existingTCards.map((item, index) => (
                                <StyledTableRow key={index} style={{ backgroundColor: item.bg, color: item.tcolor }}>
                                    <StyledTableCell width="2%">
                                        <Checkbox
                                            checked={item.isSelected}
                                            color={item.isSelected ? 'primary' : ''}
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    setState((prev) => ({ ...prev, createNewTcard: false }));
                                                }
                                                onJobSelect(e.target.checked, item.tCardsID);
                                            }}
                                            disabled={
                                                // state.createNewTcard ||
                                                item.isChecBoxkDisabled
                                            }
                                        />
                                    </StyledTableCell>
                                    <StyledTableCell width="98%">
                                        <Grid container onClick={() => handleTcardOpen(true, item.tCardsID)}>
                                            <Grid item xs={12}>
                                                <Grid container spacing={1}>
                                                    <Grid item>
                                                        <Typography style={{ fontSize: 13, fontWeight: 600, color: item.tcolor }}>
                                                            {item.bd ? moment(item.bd).format('DD/MM/YY') : 'N/A'}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item>
                                                        <Typography style={{ fontSize: 13, fontWeight: 600, color: item.tcolor }}>
                                                            {item.customer ? `Customer - ${item.customer}` : 'N/A'}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            style={{
                                                                // display: 'grid',
                                                                // rowGap: 1,
                                                                // gridTemplateColumns: 'repeat(9, 1fr)',
                                                                // justifyContent: 'flex-end'
                                                                display: 'flex'
                                                            }}
                                                        >
                                                            {legendItems
                                                                .filter((m) => item[m.st])
                                                                .map((m) => (
                                                                    <div key={m.st} style={{ margin: '0px 2px', textAlign: 'center' }}>
                                                                        <Typography
                                                                            style={{
                                                                                fontSize: 10,
                                                                                fontWeight: 600,
                                                                                background: m.background,
                                                                                color: m.color,
                                                                                padding: 2,
                                                                                width: 40
                                                                            }}
                                                                        >
                                                                            {m.label}
                                                                        </Typography>
                                                                    </div>
                                                                ))}
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12} style={{ color: item.tcolor }}>
                                                {item.notes}
                                            </Grid>
                                        </Grid>
                                    </StyledTableCell>
                                </StyledTableRow>
                            ))
                        ) : (
                            <StyledTableRow>
                                <StyledTableCell colSpan={2} align="center">
                                    No record found.
                                </StyledTableCell>
                            </StyledTableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            {openModal && <TCardDashboardModal id={tCardID} onClose={handleTcardOpen} />}
        </>
    );
};

export default ExistingCardsList;
